import { BORDER_RADIUS, BOX_SHADOW, COLORS, FONTS, SPACING } from '../themeConf';
export const notificationsStyle = {
    Containers: {
        DefaultStyle: {
            width: 500,
            top: 'auto',
            bottom: 0,
            margin: '0 auto 0 -250px',
            left: '50%',
        },
    },
    NotificationItem: {
        DefaultStyle: {
            width: 500,
            minHeight: 60,
            height: 'auto',
            border: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            paddingLeft: '5.5em',
            borderRadius: BORDER_RADIUS.default,
            boxShadow: BOX_SHADOW.default,
        },
        success: {
            backgroundColor: COLORS.primary.main,
        },
        info: {
            backgroundColor: COLORS.brand.main,
        },
        error: {
            backgroundColor: COLORS.error.main,
        },
        warning: {
            backgroundColor: COLORS.warning.main,
        },
    },
    Dismiss: {
        DefaultStyle: {
            display: 'none',
        },
    },
    Title: {
        DefaultStyle: {
            color: COLORS.font.light,
            fontSize: FONTS.size.mediumBig,
            fontWeight: FONTS.weight.bold,
            height: FONTS.size.mediumBig,
            marginBottom: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    },
    MessageWrapper: {
        DefaultStyle: {
            minHeight: 20,
            fontSize: FONTS.size.medium,
            fontWeight: FONTS.weight.normal,
            lineHeight: 1.67,
            textAlign: 'left',
            color: COLORS.font.light,
            marginTop: SPACING.margin.smallest,
        },
    },
};
//# sourceMappingURL=notificationsStyle.js.map